"use client";

import { useMemo } from "react";
import { AuthProvider } from "@contexts/auth-context";

/**
 * Reads `authToken` from browser cookies and bridges it into existing AuthContext.
 * This avoids using `cookies()` in the root server layout, keeping public pages
 * eligible for a lighter render path.
 */
function readAuthTokenFromDocumentCookie() {
   if (typeof document === "undefined") {
      return null;
   }

   const cookieEntries = document.cookie.split(";");
   for (const rawCookieEntry of cookieEntries) {
      const [rawKey, ...rawValueParts] = rawCookieEntry.split("=");
      const normalizedKey = rawKey?.trim();
      if (normalizedKey !== "authToken") {
         continue;
      }

      const serializedValue = rawValueParts.join("=");
      if (!serializedValue) {
         return null;
      }

      try {
         return decodeURIComponent(serializedValue);
      } catch {
         return serializedValue;
      }
   }

   return null;
}

export default function AuthProviderFromCookie({ children }) {
   const authToken = useMemo(() => readAuthTokenFromDocumentCookie(), []);
   return <AuthProvider value={authToken}>{children}</AuthProvider>;
}
